<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">

          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h6 class="mb-0 me-auto">Lista de Pedidos</h6>
              <div class="d-flex align-items-center gap-2">
                <router-link
                  :to="{ name: 'Purchases Create' }"
                  class="btn btn-sm btn-primary text-white"
                  title="Crear pedido"
                >
                  <i class="fa fa-plus me-1"></i> Crear pedido
                </router-link>
                <button class="btn btn-sm btn-success" @click="exportToExcel" title="Exportar a Excel">
                  <i class="fas fa-file-excel me-1"></i> Exportar Excel
                </button>
              </div>
            </div>

            <!-- se agg una row mas para la busqueda-->
            <div class="row">

              <!-- Columna de búsqueda -->
              <div class="col-md-4 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar pedido..." @input="fetchData(null)" />
              </div>

              <!-- Columna de fechas -->
              <div class="col-md-4 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>
              <div class="col-md-4 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>

            </div>

          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Proveedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total compra</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total pagado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.supplier }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatMoney(value.total) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatMoney(value.total_pagado) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': value.status == 0,
                        'bg-gradient-success': value.status == 1
                      }">
                        {{ value.status == 0 ? 'Borrador' : 'Formalizada' }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.updated_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Purchases Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i :class="value.status === 0 ? 'fa fa-pencil-alt' : 'fa fa-eye'"></i>
                      </router-link>

                      <a @click="generateDoc(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Generar PDF">
                        <i class="fa fa-file-pdf"></i>
                      </a>

                      <a @click="deleteUser(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro"
                        v-if="value.status == 0">
                        <i class="fa fa-trash"></i>
                      </a>

                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="6" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                  <tr v-if="data.length > 0" class="bg-light">
                    <td class="text-end text-sm fw-bold">Total (todas las páginas filtradas):</td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-success fw-bold">{{ formatMoney(totalFilteredAllPages) }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-info fw-bold">{{ formatMoney(totalPagadoFilteredAllPages) }}</span>
                    </td>
                    <td colspan="3"></td>
                  </tr>
                </tbody>
              </table>



              <div class="pagination p-3">
                <!-- Recorremos los links para generar los botones -->
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.label)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsList',

  data() {
    return {
      searchQuery: '',
      startDate: '',
      endDate: '',
      totalFilteredAllPages: 0,
      totalPagadoFilteredAllPages: 0,
    };
  },



  computed: {
    ...mapGetters('purchases', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.purchases.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.purchases.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['purchases/links']; // Retorna los links
    },
  },

  methods: {
    formatMoney(value) {
      return parseFloat(value ?? 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async fetchData(pageUrl = null) {
      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl
      };
      await this.$store.dispatch('purchases/fetchData', params);
      await this.fetchFilteredTotal();
    },
    async fetchFilteredTotal() {
      const params = {
        search: this.searchQuery || '',
        start_date: this.startDate || '',
        end_date: this.endDate || '',
      };
      const rows = await this.$store.dispatch('purchases/getAll', params);
      this.totalFilteredAllPages = (rows || []).reduce(
        (acc, item) => acc + parseFloat(item.total || 0),
        0
      );
      this.totalPagadoFilteredAllPages = (rows || []).reduce(
        (acc, item) => acc + parseFloat(item.total_pagado || 0),
        0
      );
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("purchases/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData();

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async generateDoc(id) {
      try {
        const response = await this.$store.dispatch("purchases/getDoc", id);

        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));

        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Compra_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();

        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al generar el documento PDF',
        });
      }
    },
    async exportToExcel() {
      try {
        // Preparar filtros para la exportación
        const filters = {};
        if (this.searchQuery) {
          filters.search = this.searchQuery;
        }
        if (this.startDate) {
          filters.start_date = this.startDate;
        }
        if (this.endDate) {
          filters.end_date = this.endDate;
        }

        // Llamar al servicio de exportación con los filtros
        const response = await this.$store.dispatch('purchases/exportData', filters);
        
        // Crear un objeto URL temporal para el archivo Excel
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace temporal para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'pedidos.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        
        // Limpiar el URL temporal
        window.URL.revokeObjectURL(url);
        
        await Swal.fire('Éxito', 'Archivo Excel exportado correctamente', 'success');
      } catch (error) {
        console.error('Error al exportar:', error);
        await Swal.fire('Error', 'No se pudo exportar el archivo Excel', 'error');
      }
    }

  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>